import {
  ModernCategory,
  ModernLesson,
  IMachine,
  ModernPathway,
} from "@/modern/types/dashboard";

export const mapMachine = (raw: any): IMachine => ({
  id: Number(raw?.id ?? 0),
  name: String(raw?.name ?? ""),
  photo_path: String(raw?.photo_path ?? ""),
  dificulty: String(raw?.dificulty ?? ""),
  total_flags: Number(raw?.total_flags ?? 0),
  os_name: String(raw?.os_name ?? ""),
  xp: Number(raw?.xp ?? 0),
  type: String(raw?.type ?? ""),
  is_freemium: Boolean(raw?.is_freemium),
  percentage: Number(raw?.percentage ?? 0),
  release_at: String(raw?.release_at ?? ""),
  is_free_week_rotation: Boolean(raw?.is_free_week_rotation),
  free_week_rotation_ends_at: raw?.free_week_rotation_ends_at
    ? String(raw.free_week_rotation_ends_at)
    : null,
  free_week_rotation_starts_at: raw?.free_week_rotation_starts_at
    ? String(raw.free_week_rotation_starts_at)
    : null,
});

export const mapPathway = (raw: any): ModernPathway => ({
  id: Number(raw?.id ?? 0),
  image: String(raw?.image ?? ""),
  name: String(raw?.name ?? ""),
  short_description: String(raw?.short_description ?? ""),
  level: String(raw?.level ?? ""),
  type: String(raw?.type ?? ""),
  percentage_completed: Number(raw?.percentage_completed ?? 0),
  completed_machines: Number(raw?.completed_machines ?? 0),
  total_machines: Number(raw?.total_machines ?? 0),
  completed_challenges: Number(raw?.completed_challenges ?? 0),
  total_challenges: Number(raw?.total_challenges ?? 0),
  completed_lessons: Number(raw?.completed_lessons ?? 0),
  total_lessons: Number(raw?.total_lessons ?? 0),
});

export const mapLesson = (raw: any): ModernLesson => ({
  id: Number(raw?.id ?? 0),
  title: String(raw?.title ?? ""),
  image_url: String(raw?.image_url ?? ""),
  is_free: Boolean(raw?.is_free),
  module_id: raw?.module_id ? Number(raw.module_id) : undefined,
});

export const mapCategory = (raw: any): ModernCategory => ({
  id: Number(raw?.id ?? 0),
  name: String(raw?.name ?? ""),
  percentage: String(raw?.percentage ?? "0"),
});
